import { Button as ChakraButton, Flex } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';

interface LHCDetailEmptyStateProps {
  onSearchSuratJalan: () => void;
}

export function LHCDetailEmptyState({
  onSearchSuratJalan,
}: LHCDetailEmptyStateProps) {
  return (
    <Flex direction="column" align="center" justify="center" py={20} gap={4}>
      <Text fontSize="lg" fontWeight="bold">
        Belum ada input data LHC
      </Text>
      <Text fontSize="sm" color="gray.500" textAlign="center">
        Silakan cari nomor surat jalan untuk membuat data Laporan Harian Anda
      </Text>
      <ChakraButton
        colorScheme="blue"
        bgColor="#0000A3"
        color="white"
        leftIcon={<ContentPasteSearchIcon fontSize="small" />}
        size="md"
        mt={4}
        onClick={onSearchSuratJalan}
      >
        Cari Surat Jalan
      </ChakraButton>
    </Flex>
  );
}
